import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foreportsApi = api.injectEndpoints({
  endpoints: builder => ({
    getFOBalacne: builder.query<any, any>({
      query: cid => `foreports/balance/${cid}`
    }),
    getFOPolice: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/police/${cid}/${fdt}/${tdt}`
    }),
    getFOReports: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/cashier/${cid}/${fdt}/${tdt}`
    }),
    getFODayBook: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/daybook/${cid}/${fdt}/${tdt}`
    }),
    getFOCheckinAc: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/checkinac/${cid}/${fdt}/${tdt}`
    }),
    getFOCheckoutAc: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/checkoutac/${cid}/${fdt}/${tdt}`
    }),
    getRevenueByDepartment: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `foreports/revenue-department/${cid}/${fdt}/${tdt}`
    }),
    getFOOccupancyFlash: builder.query<any, any>({
      query: ({ cid, date }) => `foreports/occupancyflash/${cid}/${date}`
    }),
    getFORevenue: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/revenue/${cid}/${fdt}/${tdt}`
    }),
    getFOSearch: builder.query<any, any>({
      query: ({ cid, type, fdt, tdt }) =>
        `foreports/search/${cid}/${type}/${fdt}/${tdt}`
    }),
    getInHouse: builder.query<any, any>({
      query: cid => `foreports/inhouse/${cid}`
    }),
    getFOTax: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/tax/${cid}/${fdt}/${tdt}`
    }),
    getFOGSTR1: builder.mutation<any, any>({
      query({ cid, fdt, tdt }) {
        return {
          url: `foreports/gstr/${cid}/${fdt}/${tdt}`,
          method: 'GET',
          responseHandler: async (response) => {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'GSTR1_' + fdt + '_' + tdt + '.json';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          },
          cache: 'no-cache'
        };
      }
    }),
    getFOMonthly: builder.query<any, any>({
      query: ({ cid, dt }) => `foreports/monthly/${cid}/${dt}`
    }),
    getFOCharges: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/charges/${cid}/${fdt}/${tdt}`
    }),
    getFOOTASales: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/footasales/${cid}/${fdt}/${tdt}`
    }),
    getFOOutstanding: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) =>
        `foreports/fooutstanding/${cid}/${fdt}/${tdt}`
    }),
    getFOTourism: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/fotourism/${cid}/${fdt}/${tdt}`
    }),
    getFORatePost: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/foratepost/${cid}/${fdt}/${tdt}`
    }),
    getFOReceipts: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/foreceipts/${cid}/${fdt}/${tdt}`
    }),
    getDFRCheckout: builder.query<any, any>({
      query: ({ cid, dt }) => `foreports/dfrcheckout/${cid}/${dt}`
    }),
    getFOTrans: builder.query<any, any>({
      query: id => `foreports/fotrans/${id}`
    }),
    getFOCITrans: builder.query<any, any>({
      query: id => `foreports/focitrans/${id}`
    }),
    getFOLog: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/log/${cid}/${fdt}/${tdt}`
    }),
    getFOPlanSales: builder.query<any, any>({
      query: ({ fdt, tdt }) => `foreports/plansales/${fdt}/${tdt}`
    }),
    getFOHouseGuest: builder.query<any, any>({
      query: ({ fdt, tdt }) => `foreports/houseguest/${fdt}/${tdt}`
    }),
    getFOCashClose: builder.query<any, any>({
      query: ({ fdt, tdt }) => `foreports/cashclose/${fdt}/${tdt}`
    }),
    getFOHighBalance: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `foreports/highbalance/${cid}/${fdt}/${tdt}`,
      providesTags: ['Collection']
    }),
    getFOAddrBook: builder.query<any, any>({
      query: cid => `foreports/addrbook/${cid}`
    }),
    getFOCustomers: builder.query<any, any>({
      query: cid => `foreports/customers/${cid}`
    }),
    getManagerReport: builder.query<any, any>({
      query: ({ cid, date }) => `foreports/managerreport/${cid}/${date}`
    }),
    getManagerReportTomorrow: builder.query<any, any>({
      query: ({ cid, date }) => `foreports/managerreport/tomorrow/${cid}/${date}`
    })
  }),
  overrideExisting: false
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOBalacneQuery,
  useGetFOPoliceQuery,
  useGetFOReportsQuery,
  useGetFODayBookQuery,
  useGetFOCheckinAcQuery,
  useGetFOCheckoutAcQuery,
  useGetFORevenueQuery,
  useGetRevenueByDepartmentQuery,
  useGetFOOccupancyFlashQuery,
  useGetFOSearchQuery,
  useGetInHouseQuery,
  useGetFOTaxQuery,
  useGetFOGSTR1Mutation,
  useGetFOMonthlyQuery,
  useGetFOChargesQuery,
  useGetFOOTASalesQuery,
  useGetFOOutstandingQuery,
  useGetFOTourismQuery,
  useGetFORatePostQuery,
  useGetFOReceiptsQuery,
  useLazyGetFOCheckoutAcQuery,
  useGetDFRCheckoutQuery,
  useGetFOTransQuery,
  useGetFOCITransQuery,
  useGetFOLogQuery,
  useGetFOPlanSalesQuery,
  useGetFOHouseGuestQuery,
  useGetFOCashCloseQuery,
  useGetFOHighBalanceQuery,
  useGetFOAddrBookQuery,
  useGetFOCustomersQuery,
  useGetManagerReportQuery,
  useLazyGetManagerReportQuery,
  useGetManagerReportTomorrowQuery,
  useLazyGetManagerReportTomorrowQuery
} = foreportsApi;

